import request from "@/utils/request";
import Utils from "@/utils/index";

export default {
  async login({ account, password, companyName }: any): Promise<any> {
    return request.post("/Security/SignIn", {
      CompanyName: companyName,
      Account: account,
      Password: password,
      AppSource: 4
    });
  },
  async updateChatInfo(params) {
    return request.post("/ChatUser/UpdateSettings", params);
  },
  async wechatLogin(openId) {
    return request.get(`${process.env.VUE_APP_MM_URL}/user/loginwechat?openId=${openId}`);
  },
  async info(id = null): Promise<any> {
    return request.post("/ChatUser/GetUserInfo", {
      UserId: id
    });
  },
  async companyInfo(id: string) {
    return request.post("/ChatUser/GetCompanyInfo", {
      CompanyId: id
    });
  },
  async companyDetail(id: string, name: string) {
    return request.post("/Supplier/GetBusinessCard", {
      CompanyName: name,
      CompanyId: id
    });
  },
  async beansList(
    { pageIndex, pageSize, date } = {
      pageIndex: 1,
      pageSize: 10,
      date: Utils.getNowMonth()
    }
  ) {
    return request.post("/EnergyBeans/GetBeansPage", {
      PageIndex: pageIndex,
      PageSize: pageSize,
      Date: date
    });
  },
  async balanceList(
    { pageIndex, pageSize, date } = {
      pageIndex: 1,
      pageSize: 10,
      date: Utils.getNowMonth()
    }
  ) {
    return request.post("/Money/MyMoneyFlow", {
      PageIndex: pageIndex,
      PageSize: pageSize,
      Date: date
    });
  },
  async beansNum() {
    return request.post("/ChatUser/MyInfo");
  },
  async getWeChatInfo() {
    return request.post("/ChatUser/MyDetail");
  },
  async updateNickName(nickName: string) {
    return request.post("/ChatUser/UpdateInfo", {
      NickName: nickName
    });
  }
};
